import React from 'react';
import Image from 'next/image';
import AboutUsTeam from '@assets/images/aboutUsTeam.png';
import AboutUsTeamHorizontal from '@assets/images/aboutUsTeamHorizontal.png';
import classNames from 'classnames';
import TeamMembers from '../../constants/TeamMembers';
import TeamMemberCard from './components/TeamMemberCard';
import styles from './styles.module.scss';

const Team = () => (
  <div className={styles.teamContainer}>
    <Image
      alt="Team Background Image"
      src={AboutUsTeam}
      fill
      className={styles.teamContainerBackgroundImage}
    />
    <Image
      alt="Team Background Image In Mobile"
      fill
      src={AboutUsTeamHorizontal}
      className={classNames(
        styles.teamContainerBackgroundImage,
        styles.modTeamContainerBackgroundImageMobileOnly,
      )}
    />
    <div className={styles.title}>Our Team</div>
    <div className={styles.teamSection}>
      {TeamMembers.map((member) => (
        <TeamMemberCard
          name={member.name}
          detail={member.detail}
          title={member.title}
          imageFile={member.imageFile}
          key={member.name}
          linkedInUrl={member.linkedInUrl}
        />
      ))}
    </div>
  </div>
);

export default Team;
